import Website from "./Website";
import HomepageSocialPreview from "./HomepageSocialPreview";
import SharePage from "./share/SharePage";
import SharePreviewRenderPage from "./share/SharePreviewRenderPage";

export const DISCORD_LINK = "https://discord.gg/XTxUgUAFJh";

export default function App() {
  if (
    (process.env.NODE_ENV === "development" ||
      process.env.REACT_APP_ENABLE_PREVIEW_RENDER === "true") &&
    window.location.pathname.startsWith("/share-preview-render/")
  ) {
    return <SharePreviewRenderPage />;
  }
  if (
    (process.env.NODE_ENV === "development" ||
      process.env.REACT_APP_ENABLE_PREVIEW_RENDER === "true") &&
    window.location.pathname === "/homepage-social-preview"
  ) {
    return <HomepageSocialPreview />;
  }
  if (window.location.pathname.startsWith("/share/")) {
    return <SharePage />;
  }
  return <Website />;
}
